const BASE='/vendor/pdfjs-6.4.299/'
let pending
export function loadPdfJs() {
  if(!pending)pending=import(/* webpackIgnore: true */ '/vendor/pdfjs-6.4.299/pdf.mjs').then(library=>{
    library.GlobalWorkerOptions.workerSrc=BASE+'pdf.worker.mjs'
    return library
  }).catch(error=>{pending=null;throw error})
  return pending
}
export const pdfResourceOptions={
  cMapUrl:BASE+'cmaps/',cMapPacked:true,standardFontDataUrl:BASE+'standard_fonts/',wasmUrl:BASE+'wasm/',
  isEvalSupported:false,enableXfa:false,useSystemFonts:false,maxImageSize:16000000,
}
